<template>
  <section>
    <div class="bg">
      <svg width="119" height="33">
        <image href="~@/assets/digitaljoy-dark-theme.svg" width="119" height="33" />
      </svg>
      <div class="top" :style="{ width: progress + '%' }">
        <svg width="119" height="33">
          <image href="~@/assets/digitaljoy-dark-theme.svg" width="119" height="33" />
        </svg>
      </div>
    </div>
  </section>
</template>

<script>
import {
  mapGetters,
  mapMutations
} from 'vuex';

export default {
  name: 'Preloader',
  data() {
    return {
      timer: null,
      progress: 0
    }
  },
  props: {
  },
  computed: {
    ...mapGetters('poll', [
      'isFeedbackPoll'
    ])
  },
  methods: {
    ...mapMutations('poll', ['setLoaded'])
  },
  mounted() {
    this.timer = setInterval(() => {
      this.progress = this.progress + 25;
      if (this.progress >= 100) {
        clearInterval(this.timer);
        setTimeout(() => {
          this.setLoaded({ isFeedbackType: this.isFeedbackPoll });
        }, 300);
      }
    }, 250);
  }
}
</script>

<style scoped lang="scss">
section {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0 !important;
  top: 0 !important;
  width: 100%;
  height: 100%;
  background: var(--preloader-bg);
  z-index: 105;
}

.bg {
  position: relative;
}

.bg > svg {
  opacity: 0.2;
}

.top {
  position: absolute;
  top: 0;
  left: 0;
  right: 100%;
  overflow: hidden;
  transition: 300ms linear;
}

.style-bbl,
.style-veev {

  section {
    display: none;
  }
}
</style>
